import React from "react";
import styles from '../styles.module.scss';
import TickSvg from "../../../components/svg/TickSvg";
import Try, {TryBtn} from "../../../components/Try";

export default function SolutionsB() {
  return <>
    <section className={styles.head}>
      <div className={styles.headContent}>
        <div className={styles.title}>
          <h4>股权招商成为政府财政新增长点</h4>
          <h1>政府招商引资<br />解决方案</h1>
          <Try />
        </div>
        <div className={styles.sticker} style={{marginLeft: "109px"}}><img src="./static-official/images/sticker-s-b.png" height={480} style={{bottom: "50px"}} alt="政府招商引资" /></div>
      </div>
    </section>
    <section className={styles.commonSection0}>
      <div className={styles.detailContainer}>
        <div className={styles.detailBlock} style={{width: "385px"}}>
          <h3>数据赋能招商与产业升级</h3>
          <desc>通过智能化数据报告、数据平台建设、线上线下活动赋能等多种方式，从地区视角，实时更新 企业、资本、产业等多维度数据，提供独具特色的地域股权及产业洞察。</desc>
          <ul>
            <li><h4><TickSvg />地区产业分析</h4></li>
            <li><h4><TickSvg />招商引资商机挖掘</h4></li>
            <li><h4><TickSvg />智能化企业分析报告</h4></li>
            <li><h4><TickSvg />政府引导基金底层资产管理、返投分析、迁址预警等</h4></li>
          </ul>
          <TryBtn />
        </div>
        <img src="./static-official/images/s-b.png" alt="数据赋能招商与产业升级" height={472}/>
      </div>
    </section>
  </>
}
